import React from "react";

const Portfolio = ({ data }) => {
  if (data) {
    var projects = data.projects.map(function (projects) {
      var projectImage = projects.image && projects.image !== ""
          ? "images/portfolio/" + projects.image
          : "images/portfolio/default.png";
      var paperPdfs = projects.url && projects.url !== ""
          ? (projects.url.startsWith("http") ? projects.url : "papers/" + projects.url)
          : "#";


      console.log(projectImage)

      return (
        <div key={projects.title} className="columns portfolio-item">
          <div className="item-wrap">
            <a href={paperPdfs} title={projects.title}>
              <img alt={projects.title.slice(0, 20)} src={projectImage} />
              <div className="overlay">
                <div className="portfolio-item-meta">
                  <h5>{projects.title}</h5>
                  <p>{projects.category}</p>
                </div>
              </div>
              <div className="link-icon">
                <i className="fa fa-link"></i>
              </div>
            </a>
          </div>
        </div>
      );
    });
  }

  return (
    <section id="portfolio">
      <div className="row">
        <div className="twelve columns collapsed">
          <h1>Check Out Some of My Research Papers.</h1>

          <div
            id="portfolio-wrapper"
            className="bgrid-quarters s-bgrid-thirds cf"
          >
            {projects}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Portfolio;
